/** Latest onBeforeNavigate handler registered by the active screen (not stored in reducer). */
export const bottomSummaryOnBeforeNavigateRef: { current: (() => void) | undefined } = {
  current: undefined,
};
